import axios from 'axios'
import queryString from 'query-string'

export const loginWithSteamTicketNoPrompt = (steamTicket, ssoUrl) =>
    new Promise((resolve, reject) => {
        if (!ssoUrl) {
            reject(new Error('Steam login: SSO url is not defined'))
            return
        }

        console.info('Steam login: Exchanging ticket for SSO code')
        axios
            .get(`${ssoUrl}&steam_ticket=${steamTicket}`, {
                maxRedirects: 2,
            })
            .then((response) => {
                // Extract the query from the URL we got redirected to
                const query = queryString.parse(response.request.responseURL)

                // If the query is null or has no code we reject this URL
                if (!query || !query.code) {
                    const err = new Error('Steam login: Could not extract SSO code from response')
                    reject(err)
                    return
                }

                console.info('Steam login: Code received, attempting login...')

                // Use the backend SSO code command to finish login
                resolve(window.ssoCode(query.code, true))
            })
            .catch(e => reject(`Steam login: ${e}`))
    })

export const loginWithSteamTicket = (steamTicket, ssoUrl) =>
    new Promise((resolve, reject) => {
        if (!ssoUrl) {
            reject(new Error('Steam login: SSO url is not defined'))
            return
        }

        console.info('Steam login: Code received, opening login window...')
        const link = document.createElement('a')
        link.id = `ticket_${steamTicket}`
        link.href = `${ssoUrl.replace('{steamTicket}', steamTicket)}`
        link.target = '_blank'
        link.click()
    })



// WEBPACK FOOTER //
// ./src/features/Steam/components/TicketExchange/index.js